import { QueryModelCore } from "@/core/model.core";

export default class Mem {
  /**
   * 获取个人中心公众号关注图片
   */
  async getOfficialAccountsImage() {
    const result = await new QueryModelCore('/api-mem/personal/center/getAppQrCode').get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
 * 提交意见反馈
 * @param {number} tipType 意见类型
 * @param {string} tip 意见内容
 */
  async addFeedback(tipType, tip) {
    const result = await new QueryModelCore('/api-mem/personal/center/addUserTip').post({ tipType, tip, channel: 105 });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取足迹信息
   */
  async getFootprint(params) {
    const result = await new QueryModelCore('/api-mem/personal/center/queryFootMark').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
 * 记录足迹
 * @param {number} type 类型 1-进入页面 2-离开页面
 * @param {string} pathUrl 当前页面路径
 */
  async recordFootprint(params) {
    const result = await new QueryModelCore('/api-mem/footMark').post(params);
    const { dataMap } = result;
    return dataMap;
  }

}